import React from 'react';

// Shared severity palette for the "ink" design system (sidebar, header, Dashboard,
// and any page rebuilt to match /login). Chip text always stays the neutral ink
// color — only the small square marker carries the hue — so severity is never
// conveyed by color alone.
export const SEVERITY = {
  crit: { label: 'CRITICAL', fg: 'var(--sev-crit-fg)', bg: 'var(--sev-crit-bg)' },
  high: { label: 'HIGH', fg: 'var(--sev-high-fg)', bg: 'var(--sev-high-bg)' },
  med: { label: 'MEDIUM', fg: 'var(--sev-med-fg)', bg: 'var(--sev-med-bg)' },
  low: { label: 'LOW', fg: 'var(--sev-low-fg)', bg: 'var(--sev-low-bg)' },
  good: { label: 'HEALTHY', fg: 'var(--sev-good-fg)', bg: 'var(--sev-good-bg)' },
};

const SeverityChip = ({ level, label, className = '' }) => {
  const sev = SEVERITY[level] || SEVERITY.low;
  return (
    <span
      className={`inline-flex items-center gap-1.5 h-[22px] px-2 rounded-md font-mono text-[10.5px] font-medium tracking-[0.06em] ${className}`}
      style={{ background: sev.bg, color: 'var(--ink-text)' }}
    >
      <span className="w-1.5 h-1.5 rounded-[1px] shrink-0" style={{ background: sev.fg }} />
      {label || sev.label}
    </span>
  );
};

export default SeverityChip;
